export const HIGH_SCHOOLS = [
    {
        lat: 39.5870,
        long: 105.0037,
        title: 'Heritage High School',
        rating: 9,
        address: '1401 W Geddes Ave, Littleton, CO 80120'
    }
];

export const ADDRESSES_OF_NOTE = [
    {
        title: 'Harshberger Haven',
        address: '1126 Berganot Trail, Castle Pines, CO 80108'
    },
    {
        title: 'King Soopers',
        address: 'King Soopers'
    }
]